import { langData } from '../src/lang';

export const ADMIN_GIVE_REWARD_REASON_LIST: {
    type: string;
    img?: string;
    title: langData;
    text: langData;
}[] = [{ type: 'ERROR COMPENSATION', title: 'compensateTitle', text: 'compensateText' }];
